import React from 'react';
import PropTypes from 'prop-types';
import WidgetPerformanceBlock from './WidgetPerformanceBlock';
import styles from './WidgetPerformance.module.scss';

const PagePerformanceBlock = ({ page }) => (
  <div className={styles.widgetList}>
    {page.widgets.map(widget => (
      <WidgetPerformanceBlock widget={widget} key={widget.id} />
    ))}
  </div>
);

PagePerformanceBlock.propTypes = {
  page: PropTypes.shape({
    widgets: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

export default PagePerformanceBlock;
